'use client';

import { c as _c } from "react/compiler-runtime";
import { Breadcrumb } from '@7f-ui/components/breadcrumb/breadcrumb';
import type { NexperienceSearchItemFragment } from '@data-access/lib/gql/experience/documents';
import type { HTMLAttributes, PropsWithChildren } from 'react';
import { PartnerCategories } from 'src/app/partner/_components/partner-categories';
import { PartnerExperiences } from 'src/app/partner/_components/partner-experiences';
import { PartnerGallery } from 'src/app/partner/_components/partner-gallery';
import { PartnerHeader } from 'src/app/partner/_components/partner-header';
import { PartnerLocations } from 'src/app/partner/_components/partner-locations';
import { PartnerUpcomingDates } from 'src/app/partner/_components/partner-upcoming-dates';
import { splitAboutTextParagraphs } from 'src/app/partner/_lib/partner-about-text';
import type { PartnerProfileData } from 'src/app/partner/_lib/partner-server';
import { buildPartnerUrl } from 'src/app/partner/_lib/partner-url';
type PartnerDetailPageClientProps = {
  partner: PartnerProfileData;
  experiences: NexperienceSearchItemFragment[];
};
export function PartnerDetailPageClient(t0) {
  const $ = _c(55);
  const {
    partner,
    experiences
  } = t0;
  const t1 = partner.name;
  let t2;
  if ($[0] !== partner.publicId || $[1] !== partner.slug) {
    t2 = buildPartnerUrl({
      publicId: partner.publicId,
      slug: partner.slug
    });
    $[0] = partner.publicId;
    $[1] = partner.slug;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== partner.name || $[4] !== t2) {
    t3 = [{
      label: t1,
      url: t2,
      truncate: true
    }];
    $[3] = partner.name;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const breadcrumbs = t3;
  let t4;
  if ($[6] !== partner) {
    t4 = <PartnerHeader partner={partner} />;
    $[6] = partner;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = !partner.categories.length;
  let t6;
  if ($[8] !== partner.categories) {
    t6 = <PartnerCategories categories={partner.categories} />;
    $[8] = partner.categories;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t5 || $[11] !== t6) {
    t7 = <Section className="pt-8 pb-8 md:pt-10" hidden={t5}>{t6}</Section>;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const t8 = `Über “${partner.name}”`;
  let t9;
  if ($[13] !== t8) {
    t9 = <SectionTitle>{t8}</SectionTitle>;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== partner.aboutText) {
    t10 = splitAboutTextParagraphs(partner.aboutText).map(_temp);
    $[15] = partner.aboutText;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== partner.galleryImages) {
    t11 = partner.galleryImages.length > 0 && <div className="mt-8 sm:mt-16"><PartnerGallery images={partner.galleryImages} /></div>;
    $[17] = partner.galleryImages;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t10 || $[20] !== t11 || $[21] !== t9) {
    t12 = <Section className="py-8">{t9}{t10}{t11}</Section>;
    $[19] = t10;
    $[20] = t11;
    $[21] = t9;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  const t13 = experiences.length === 0;
  const t14 = `Erlebnisse von "${partner.name}" (${partner.experienceCount})`;
  let t15;
  if ($[23] !== experiences || $[24] !== partner.publicId || $[25] !== t14) {
    t15 = <PartnerExperiences title={t14} merchantPublicId={partner.publicId} experiences={experiences} />;
    $[23] = experiences;
    $[24] = partner.publicId;
    $[25] = t14;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== t13 || $[28] !== t15) {
    t16 = <Section className="full-bleed py-8" hidden={t13}>{t15}</Section>;
    $[27] = t13;
    $[28] = t15;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  const t17 = partner.upcomingDates.length === 0;
  let t18;
  if ($[30] !== partner.publicId || $[31] !== partner.upcomingDates) {
    t18 = <PartnerUpcomingDates title={"N\xE4chste Termine"} merchantPublicId={partner.publicId} dates={partner.upcomingDates} />;
    $[30] = partner.publicId;
    $[31] = partner.upcomingDates;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  let t19;
  if ($[33] !== t17 || $[34] !== t18) {
    t19 = <Section className="full-bleed py-8" hidden={t17}>{t18}</Section>;
    $[33] = t17;
    $[34] = t18;
    $[35] = t19;
  } else {
    t19 = $[35];
  }
  const t20 = experiences.length === 0;
  let t21;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <SectionTitle>Erlebnisorte</SectionTitle>;
    $[36] = t21;
  } else {
    t21 = $[36];
  }
  let t22;
  if ($[37] !== experiences || $[38] !== partner.publicId) {
    t22 = <PartnerLocations merchantPublicId={partner.publicId} experiences={experiences} />;
    $[37] = experiences;
    $[38] = partner.publicId;
    $[39] = t22;
  } else {
    t22 = $[39];
  }
  let t23;
  if ($[40] !== t20 || $[41] !== t22) {
    t23 = <Section className="py-8" hidden={t20}>{t21}{t22}</Section>;
    $[40] = t20;
    $[41] = t22;
    $[42] = t23;
  } else {
    t23 = $[42];
  }
  let t24;
  if ($[43] !== t12 || $[44] !== t16 || $[45] !== t19 || $[46] !== t23 || $[47] !== t7) {
    t24 = <div className="sm:fluid-grid sm:fluid-container grid"><div className="col-span-12 md:col-span-8 md:col-start-3"><div className="bleed-container divide-y divide-primary/15 *:first:border-none *:last:border-primary/15 *:last:border-b sm:block sm:divide-y-0 sm:*:last:border-none!">{t7}{t12}{t16}{t19}{t23}</div></div></div>;
    $[43] = t12;
    $[44] = t16;
    $[45] = t19;
    $[46] = t23;
    $[47] = t7;
    $[48] = t24;
  } else {
    t24 = $[48];
  }
  let t25;
  if ($[49] !== breadcrumbs) {
    t25 = <Breadcrumb links={breadcrumbs} placement="bottom" />;
    $[49] = breadcrumbs;
    $[50] = t25;
  } else {
    t25 = $[50];
  }
  let t26;
  if ($[51] !== t24 || $[52] !== t25 || $[53] !== t4) {
    t26 = <>{t4}{t24}{t25}</>;
    $[51] = t24;
    $[52] = t25;
    $[53] = t4;
    $[54] = t26;
  } else {
    t26 = $[54];
  }
  return t26;
}
function _temp(paragraph, index) {
  return <p key={index} className="font-body-copy">{paragraph}</p>;
}
function Section(t0) {
  const $ = _c(3);
  const {
    children,
    hidden,
    className
  } = t0;
  if (!children || hidden) {
    return null;
  }
  let t1;
  if ($[0] !== children || $[1] !== className) {
    t1 = <section className={className}>{children}</section>;
    $[0] = children;
    $[1] = className;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
function SectionTitle(t0) {
  const $ = _c(3);
  const {
    children,
    className
  } = t0;
  const t1 = className ?? "mb-6 font-heading2 sm:mb-8";
  let t2;
  if ($[0] !== children || $[1] !== t1) {
    t2 = <h2 className={t1}>{children}</h2>;
    $[0] = children;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}